import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from 'react-bootstrap';
import { CSVLink } from 'react-csv';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import useAuthCheck from "../hooks/useAuthCheck";

const Enquiry2 = () => {
  const [formDataList, setFormDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  useEffect(() => {
    fetchData();
  }, []);

  //auth
  useAuthCheck();
  const navigate = useNavigate();

  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const username = userData?.username;
  //

  const fetchData = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL_FORM1);
      setFormDataList(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const deleteRecord = async (id) => {
    try {
      await axios.delete(`https://kedarnathconstruction.com/api/3d2a1b6c-8e9f-4a7b-b5d6-c8f2a3e4d7e9/9f4b2e8a-6d85-4e6b-a49c-7f1d1f2c3a91/get2.php?id=${id}`);
      toast.success("Record deleted successfully");
      fetchData(); // Refresh the list after deletion
    } catch (error) {
      toast.error("Error deleting record");
      console.error('Error deleting data:', error);
    }
  };

  const exportCSV = () => {
    const csvData = formDataList.map(formData => ({
      Name: formData.name,
      Email: formData.email,
      'Mobile Number': formData.mobile_number,
      'Property Option': formData.property_option,
      'Created At': formData.created_at,
    }));
    return csvData;
  };

  const exportPDF = () => {
    const unit = 'pt';
    const size = 'A4';
    const orientation = 'landscape';
    const doc = new jsPDF(orientation, unit, size);

    const headers = [['Name', 'Email', 'Mobile Number', 'Property Option', 'Created At']];
    const dataRows = formDataList.map(formData => [
      formData.name,
      formData.email,
      formData.mobile_number,
      formData.property_option,
      formData.created_at,
    ]);

    doc.autoTable({
      head: headers,
      body: dataRows,
    });

    doc.save('formData.pdf');
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const paginate = (items, pageNumber, itemsPerPage) => {
    const startIndex = (pageNumber - 1) * itemsPerPage;
    return items.slice(startIndex, startIndex + itemsPerPage);
  };

  const paginatedFormDataList = paginate(formDataList, currentPage, itemsPerPage);
  const totalPages = Math.ceil(formDataList.length / itemsPerPage);

  return (
    <div className="container mx-auto mt-5 p-4">
      {/* auth part */}
      <Toaster />
      <div className="flex flex-col md:flex-row items-center justify-between w-full p-6 bg-white shadow-lg">
        <h1 className="text-2xl font-bold text-gray-800">Welcome, {username}!</h1>
        <button
          className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
          onClick={() => {
            toast.success("You have successfully logged out!");
            sessionStorage.removeItem("loggedIn");
            sessionStorage.removeItem("userData");
            navigate("/");
          }}
        >
          Logout
        </button>
      </div>
      <h2 className="mb-4 text-2xl font-semibold text-center">Enquiry Data</h2>
      <div className="mb-3 flex space-x-2 justify-center">
        <CSVLink
          data={exportCSV()}
          filename={'formData.csv'}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          target="_blank"
        >
          Export CSV
        </CSVLink>
        <Button
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
          onClick={exportPDF}
        >
          Export PDF
        </Button>
      </div>
      <div className="overflow-x-auto">
        <table className="table-auto w-full bg-white shadow-md rounded my-6">
          <thead className="bg-gray-200">
            <tr>
              <th className="py-2 px-4 border-b">Name</th>
              <th className="py-2 px-4 border-b">Email</th>
              <th className="py-2 px-4 border-b">Mobile Number</th>
              <th className="py-2 px-4 border-b">Property Option</th>
              <th className="py-2 px-4 border-b">Created At</th>
              <th className="py-2 px-4 border-b">Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedFormDataList.map((formData, index) => (
              <tr key={index} className="text-center">
                <td className="py-2 px-4 border-b">{formData.name}</td>
                <td className="py-2 px-4 border-b">{formData.email}</td>
                <td className="py-2 px-4 border-b">{formData.mobile_number}</td>
                <td className="py-2 px-4 border-b">{formData.property_option}</td>
                <td className="py-2 px-4 border-b">{formData.created_at}</td>
                <td className="py-2 px-4 border-b">
                  <button
                    onClick={() => deleteRecord(formData.id)}
                    className="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-3 rounded"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-center mt-4">
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index}
            onClick={() => handlePageChange(index + 1)}
            className={`mx-1 px-3 py-1 rounded ${currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
          >
            {index + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Enquiry2;
